module.exports = __webpack_public_path__ + "static/media/member1.ea01aebd.jpg";